import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { DropdownItem } from 'reactstrap';
import { Dispatch } from 'redux';
import { hasPrivilege, adEnabled, ssoEnabled } from '../../../stores/auth/selectors';
import { RootState } from '../../../stores/store';
import { selected } from '../../../stores/tables/selectors';
import { sendMigratePasswordMail } from '../../../stores/users/actionCreators';
import ConfirmModal from '../../common/modals/ConfirmModal';

interface Props extends LocalizeContextProps {
    hasPrivilege: (privileges: string[]) => boolean;
    selected: string[];
    adEnabled?: boolean;
    ssoEnabled?: boolean;

    sendMigratePasswordMail: (ids: string[]) => void;
}

interface State {
    showModal: boolean;
}

class SendMigratePasswordMailAction extends React.Component<Props, State> {
    public constructor(props: Props) {
        super(props);
        this.state = {
            showModal: false,
        };
    }

    public render() {
        const t = this.props.translate;
        if (!(this.props.adEnabled || this.props.ssoEnabled) &&
            this.props.hasPrivilege(['SUPER_ADMIN', 'ADMIN'])) {
            return (
                <React.Fragment>
                    <DropdownItem
                        onClick={() => {
                            this.setState({ showModal: true });
                        }}
                    >
                        <FontAwesomeIcon icon={['fal', 'envelope-open']} />
                        {t('users.button.sendMigratePasswordMail')}
                    </DropdownItem>
                    <ConfirmModal
                        header={t('users.modal.mail.header') as string}
                        confirmText={t('users.modal.mail.mail') as string}
                        isOpen={this.state.showModal}
                        confirm={() => {
                            this.props.sendMigratePasswordMail(this.props.selected);
                        }}
                        cancel={() => { this.setState({ showModal: false }); }}
                    >
                        {t('users.modal.mail.text') as string}
                    </ConfirmModal>
                </React.Fragment>
            );
        } else {
            return null;
        }
    }
}

const mapStateToProps = (state: RootState) => ({
    hasPrivilege: hasPrivilege(state),
    selected: selected(state, 'users'),
    adEnabled: adEnabled(state),
    ssoEnabled: adEnabled(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    sendMigratePasswordMail: (ids: string[]) => dispatch(sendMigratePasswordMail(ids)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(SendMigratePasswordMailAction));